export const SET_USER = "MARKETPLACE/SET_USER"
export const UPDATE_USER = "MARKETPLACE/UPDATE_USER"
export const SET_ACCESS_TOKEN = "MARKETPLACE/SET_ACCESS_TOKEN"
export const SET_MODAL = "MARKETPLACE/SET_MODAL" 
export const SET_TICKETS = "MARKETPLACE/SET_TICKETS" 
export const SET_TOAST = "MARKETPLACE/SET_TOAST" 
export const RESET_TOAST = "MARKETPLACE/RESET_TOAST" 
export const SET_EVENT = "MARKETPLACE/SET_EVENT" 
export const SET_BATCHES = "MARKETPLACE/SET_BATCHES" 
export const SET_CART = "MARKETPLACE/SET_CART" 
export const SET_SIDEBAR = "MARKETPLACE/SET_SIDEBAR" 
export const SET_ORDER = "MARKETPLACE/SET_ORDER" 